"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXT_CODEC = exports.AUDIO_CODEC = exports.VIDEO_CODEC = void 0;
exports.VIDEO_CODEC = {
    H264: 'h264',
    H265: 'h265',
    AV1: 'av1',
    VP8: 'vp8',
    VP9: 'vp9',
};
exports.AUDIO_CODEC = {
    AAC: 'aac',
    AC3: 'ac3',
    EAC3: 'eac3',
    OPUS: 'opus',
    VORBIS: 'vorbis',
    FLAC: 'flac',
};
exports.TEXT_CODEC = {
    VTT: 'vtt',
    TTML: 'ttml',
    SRT: 'srt',
    CEA608: 'cea608',
};
//# sourceMappingURL=Codecs.js.map